import { Skeleton } from '@lanekassen/ui';
import { ForsideEpiContent } from '../epitekster/types';
import NoeGikkGalt from '../components/NoeGikkGalt';
import { useTeksterQuery } from '../hooks/queries';
import { ForsideteksterContext } from './forsideteksterContext';

export function ForsideteksterContextProvider({ children }: { children: React.ReactNode }) {
  const { data: forsideTekster, isLoading, isError } = useTeksterQuery<ForsideEpiContent>('Forside');

  if (isLoading) {
    return <Skeleton width="100%" height="200px" />;
  }
  if (isError || !forsideTekster) {
    return <NoeGikkGalt />;
  }

  return <ForsideteksterContext value={forsideTekster}>{children}</ForsideteksterContext>;
}
